import { post, get } from 'src/tools/server';

const getVouchersList = (body, startIndex, size) => {
  return post<any>(
    `/portal/discount/vouchers/${startIndex}/${size}`,
    body || {},
    {},
  );
};

const getVouchersListPage = (body, startIndex, size) => {
  return post<any>(
    `/portal/discount/voucherListPage/${startIndex}/${size}`,
    body || {},
    {},
  );
};

const getVoucherDetail = (salesChannelUuid, uuid, params) => {
  return get<any>(
    `/portal/discount/salesChannelVoucher/${salesChannelUuid}/${uuid}`,
    params || {},
  );
};

const postVoucherDetail = (body, params) => {
  return post<any>(`/portal/discount/salesChannelVoucher`, body, params || {});
};

export {
  getVouchersList,
  getVouchersListPage,
  getVoucherDetail,
  postVoucherDetail,
};
